export default "__VITE_ASSET__CmCbvri$__"